import {
  createQuery,
  createSuspenseQuery
} from "../../utils/queryFactories.js";
import { api } from "../../utils/fetch.js";
import { z } from "zod";
import { ChecklistResponseSchema } from "../../schemas/checklistV2.js";

export type ChecklistResponse = z.infer<typeof ChecklistResponseSchema>;
type Response = ChecklistResponse;

const wfRequest = z.object({
  api: z.literal("wf"),
  checklist_id: z.number()
});
const publicRequest = z.object({
  api: z.literal("public"),
  checklist_id: z.number(),
  slug: z.string()
});

const ChecklistRequestSchema = z.discriminatedUnion("api", [
  wfRequest,
  publicRequest
]);

const ChecklistRequestVariables = z.union([
  wfRequest.omit({ api: true }),
  publicRequest.omit({ api: true })
]);

type Request = z.infer<typeof ChecklistRequestSchema>;

const urls = {
  wf: "/checklist/:checklist_id",
  public: "/public/:slug/checklist/:checklist_id"
};

export const useChecklist = createQuery<Response, Request, Error>({
  queryKey: ["checklist"],
  staleTime: 1000 * 60,
  fetcher: async (variables) => {
    const { api: checklistAPI, ...rest } = variables;
    return api<Omit<Request, "api">, Response>({
      method: "GET",
      url: urls[checklistAPI],
      requestSchema: ChecklistRequestVariables,
      responseSchema: ChecklistResponseSchema,
      body: rest
    });
  }
});

export const useChecklistSuspense = createSuspenseQuery<
  Response,
  Request,
  Error
>({
  queryKey: ["checklist"],
  staleTime: 1000 * 60,
  fetcher: async (variables) => {
    const { api: checklistAPI, ...rest } = variables;
    return api<Omit<Request, "api">, Response>({
      method: "GET",
      url: urls[checklistAPI],
      requestSchema: ChecklistRequestVariables,
      responseSchema: ChecklistResponseSchema,
      body: rest
    });
  }
});
